"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offer = void 0;
const helpers_1 = require("@lemonone/helpers");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const useIntlScope_1 = require("../../hooks/useIntlScope");
const DetailsList_1 = require("../DetailsList");
const Link_1 = require("../Link");
const Typography_1 = require("../Typography");
const Offer_module_css_1 = __importDefault(require("./Offer.module.css"));
const mapSkillsToCategories = (skills) => {
    return [
        ...new Set(skills.map(skill => {
            var _a;
            const category = (_a = skill.split('.')) === null || _a === void 0 ? void 0 : _a[0];
            return category;
        }))
    ]
        .filter(Boolean)
        .sort();
};
const mapSkillsToDeliverables = (skills) => {
    return [
        ...new Set(skills.flatMap(skill => {
            return helpers_1.mapSkillToDeliverables[skill];
        }))
    ]
        .filter(Boolean)
        .sort();
};
const Offer = ({ order, offer }) => {
    const i18n = react_intl_1.useIntl();
    const intl = useIntlScope_1.useIntlScope('@lemonone/intl/text:');
    const category = useIntlScope_1.useIntlScope('@lemonone/intl/category:');
    const deliverable = useIntlScope_1.useIntlScope('@lemonone/intl/deliverable:');
    const component = useIntlScope_1.useIntlScope('@lemonone/components/Offer:');
    const items = [];
    items.push({
        icon: 'calendar',
        content: i18n.formatDate(order.shoot.start, {
            format: 'dateTime',
            timeZone: order.shoot.location.timeZoneId
        }),
        sub: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.Typography, { dimmed: true }, intl('estimatedDuration', helpers_1.getDurationParts(order.product.duration)))))
    });
    items.push({
        icon: 'location',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            order.shoot.location.name && react_1.default.createElement(react_1.default.Fragment, null,
                order.shoot.location.name,
                ", "),
            order.shoot.location.address)),
        sub: offer ? (react_1.default.createElement(Typography_1.Typography, { dimmed: true }, component('distance', {
            distance: i18n.formatNumber(offer.travelDistance),
            duration: i18n.formatNumber(offer.travelDuration)
        }))) : undefined
    });
    if (offer) {
        items.push({
            icon: 'earning',
            content: (react_1.default.createElement(react_1.default.Fragment, null, component('earnings', {
                earnings: i18n.formatNumber(offer.cost / 100, {
                    currency: offer.currency,
                    format: 'currency'
                })
            }))),
            sub: (react_1.default.createElement(Typography_1.Typography, { dimmed: true }, component('compensationContract', {
                terms: chunks => {
                    return (react_1.default.createElement(Link_1.Link, { rel: "noreferrer", href: i18n.formatMessage({ id: '@lemonone/intl/text:termsAndConditionsUrl' }), target: "_blank" }, chunks));
                }
            })))
        });
    }
    items.push({
        icon: 'id',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            order.shoot.uuid.slice(0, 8),
            ' - ',
            mapSkillsToCategories(order.product.skills)
                .map(id => category(id))
                .join(', ')))
    });
    items.push({
        icon: 'produce',
        content: react_1.default.createElement(react_1.default.Fragment, null,
            component('youNeedToProduce'),
            ":"),
        sub: (react_1.default.createElement("ul", { className: Offer_module_css_1.default.list },
            react_1.default.createElement("li", null, deliverable('photos', { photos: order.product.photosMin })),
            mapSkillsToDeliverables(order.product.skills).map((id, index) => (react_1.default.createElement("li", { key: index }, deliverable(id)))),
            order.product.internalWalkVideo && react_1.default.createElement("li", null, deliverable('internalWalkVideo')),
            order.product.proWalkVideo && react_1.default.createElement("li", null, deliverable('proWalkVideo'))))
    });
    items.push({
        icon: 'equipment',
        content: react_1.default.createElement(react_1.default.Fragment, null,
            component('equipment'),
            ":"),
        sub: (react_1.default.createElement("ul", { className: Offer_module_css_1.default.list }, helpers_1.equipmentBySkills(order.product.skills, order.product.equipment, i18n.messages).map((text, index) => (react_1.default.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: text } })))))
    });
    return react_1.default.createElement(DetailsList_1.DetailsList, { items: items });
};
exports.Offer = Offer;
//# sourceMappingURL=Offer.js.map